module.exports = __webpack_public_path__ + "img/Group 324.988e3c57.png";